import { render, staticRenderFns } from "./PageSummary.vue?vue&type=template&id=78c30fec&"
import script from "./PageSummary.vue?vue&type=script&lang=js&"
export * from "./PageSummary.vue?vue&type=script&lang=js&"
import style0 from "./PageSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports